import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { IdentityActions, IdentityActionsResponse } from '@app/core/types/identity.types';

@Injectable({ providedIn: 'root' })
export class IdentityService {
  private readonly http = inject(HttpClient);
  
  private readonly url = `${environment.url.api}/identity/me`;

  getActions(): Observable<IdentityActions> {
    return this.http
      .get<IdentityActionsResponse>(`${this.url}/actions`)
      .pipe(map((response) => response.actions));
  }
}